import {
  AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges,
  TemplateRef, ViewChild
} from '@angular/core';
import { CustomTableComponent } from '../../../../shared/ui/custom-table/components/table/custom-table.component';
import { TableConfig } from '../../../../shared/ui/custom-table/model/table-config.model';
import { Model184, Model184Miembro, Model184Validation } from '../taxes-184.model';

export interface Model184MiembroFila extends Model184Miembro {
  indice: number;
  errores: number;
}

@Component({
  selector: 'app-model-184-miembros',
  templateUrl: './model-184-miembros.component.html',
  styleUrls: ['./model-184-miembros.component.css'],
  standalone: false
})
export class Model184MiembrosComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() data: Model184;
  @Input() validaciones: Model184Validation[] = [];

  @Output() nuevo = new EventEmitter<void>();
  @Output() editar = new EventEmitter<number>();
  @Output() eliminar = new EventEmitter<number>();

  @ViewChild('table', { static: false }) t1!: CustomTableComponent;
  @ViewChild('estadoTpl', { static: true }) estadoTpl!: TemplateRef<any>;
  @ViewChild('origenTpl', { static: true }) origenTpl!: TemplateRef<any>;

  tableConfig!: TableConfig;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.tableConfig = {
      columns: [
        { key: 'errores', label: 'Estado', sortable: false, customTemplate: this.estadoTpl, width: '110px' },
        { key: 'origen', label: 'Origen', sortable: false, customTemplate: this.origenTpl, width: '110px' },
        { key: 'nif', label: 'NIF', sortable: false, width: '120px' },
        {
          key: 'nombre', label: 'Apellidos y nombre o razón social', sortable: false,
          onCellClick: (row: Model184MiembroFila) => this.editar.emit(row.indice)
        },
        { key: 'tipoParticipe', label: 'Tipo de partícipe', sortable: false, width: '130px' },
        { key: 'participacion', label: 'Participación', sortable: false, formatFn: (valor: any) => valor + ' %', width: '130px' },
        { key: 'dias', label: 'Días', sortable: false, width: '80px' }
      ],
      actions: [
        { label: 'Editar', icon: 'edit', callback: (row: Model184MiembroFila) => this.editar.emit(row.indice) },
        { label: 'Eliminar', icon: 'delete', callback: (row: Model184MiembroFila) => this.eliminar.emit(row.indice) }
      ],
      headerActions: [
        { label: 'Nuevo miembro', icon: 'add', type: 'button', callback: () => this.nuevo.emit() }
      ],
      filterView: 'model184Miembros',
      defaultFilter: {},
      selectable: false,
      pagination: false,
      noDataText: 'No hay miembros en este ejercicio'
    };
  }

  ngAfterViewInit(): void {
    this.pintar();
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.t1 && (changes['data'] || changes['validaciones'])) {
      this.pintar();
    }
  }

  private pintar(): void {
    if (!this.t1) return;

    const filas: Model184MiembroFila[] = (this.data?.miembros || []).map((item, indice) => ({
      ...item,
      indice,
      errores: this.validaciones.filter(v => (v.key || '').startsWith(`miembros[${indice}].`) && v.type !== 'WARNING').length
    }));

    this.t1.tableState.setData(filas);
    this.t1.tableState.setTotalItems(filas.length);
  }
}
